/*=====================================
    AddProductDialog

    Author: Ac
    CreateTime: 2018 / 03 / 14
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from "actions/creators";
import styled from 'styled-components';
import { Colors, DialogStyle, GlobalStyle } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import PropTypes from 'prop-types';
import Counter from 'components/commons/Counter';

/*--------------------------
    Styled
--------------------------*/
const Title = styled.h6`
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: #565151;
    text-align: center;
`;
const Description = styled.p`
    line-height: 20px;
    margin: 10px 0 16px;
    font-size: 13px;
    color: #8A807F;
    text-align: center;
    white-space: pre-wrap;
`;
const ActionWrapper = styled.div`
    margin: 20px 0 0 0;
    text-align: center;
`;
const ButtonGroup = styled.div`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
`;
const CloseButton = styled.div`
    width: 120px;
    float: left;
    line-height: 34px;
    border: 1px solid ${Colors.Red};
    background-color: transparent;
    color: ${Colors.Red};
    cursor: pointer;

    &:hover {
        color: ${Colors.LightenDarkenColor(Colors.Red, 10)};
        border: 1px solid ${Colors.LightenDarkenColor(Colors.Red, 10)};
        background-color: transparent;
    }
`;
const CounterWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
const ConfrimButton = GlobalStyle.BasicBtn.extend`
    width: 120px;
    margin: 0 12px 0 0;
    height: 36px;
`;
/*--------------------------
    Main Component
--------------------------*/
class AddProductDialog extends PureComponent {

    static propTyeps = {
        productid: PropTypes.number.isRequired,
        routeToCart: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            isLoading: false,
        };
    }

    // ------------------------------
    // 關閉
    // ------------------------------
    closeDialog = () => {

        this.props.webActions.closeAddProductDialog();
    }

    addCart = () => {

        const {
            cardProductMap,
            haslogin,
            routeToCart,
            productid,
        } = this.props;

        const { quantity } = this.state;

        if(!haslogin){
            this.needLogin();
            return;
        }

        if(quantity > 10) {
            this.openAlertDialog({
                title: '商品加入購物車失敗',
                description: '商品數量最多不得超過10',
            });
            return;
        }

        const product = cardProductMap[productid];
        const { memberprice } = product;

        const totalPrice = quantity * memberprice;

        this.setState({
            isLoading: true,
        }, () => {
            this.props.cardCartActions.addCardToCart({
                productid, count: quantity
            }).then(() => {
    
                this.setState({
                    isLoading: false,
                }, () => {
                    const params = {
                        title: '商品成功加入購物車',
                        description: `數量:${quantity}\n總價:${totalPrice}`,
                    };
        
                    if(routeToCart)
                        params.closeCallback = this.routeToCart;
        
                    this.openAlertDialog(params);
                });
    
            }, (error) => {
    
                this.setState({
                    isLoading: false,
                }, () => {
                    let errorMsg = '發生無法預期的錯誤';
                    let errorDescription = '';
        
                    if (error && error.code) {
                        switch (error.code) {
                        case 'error.privilege.noLogin':
                            return;
                        default:
                            errorMsg = error.message;
                            break;
                        }
                    }
        
                    this.openAlertDialog({
                        title: errorMsg,
                        description: errorDescription,
                    });
                });
            });
        });
    }

    routeToCart = () => {
        this.props.webActions.cupoyStateGo(CupoyRouter.STATES.MEMBER_CART);
        this.closeDialog();
    }

    openAlertDialog = params => {
        this.props.webActions.openAlertDialog(params);
        this.closeDialog();
    }

    needLogin = () => {
        this.props.webActions.needLogin();
        this.closeDialog();
    }

    addTradeNumber = () => {
        if (this.state.quantity === 10) return;
        this.setState(prevState => (
            { quantity: prevState.quantity + 1 }
        ));
    }
    
    minusTradeNumber = () => {
        if (this.state.quantity === 1) return;
        this.setState(prevState => (
            { quantity: prevState.quantity - 1 }
        ));
    }
    
    handleCountChange = event => {
    
        const { quantity } = this.state;
        const value = event.target.value;
    
        if(value === quantity) return;

        if(+value > 10) {
            this.setState({ quantity: 10 });
            return;
        }
    
        this.setState({ quantity: +value });
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {
        const {
            productid,
            cardProductMap,
        } = this.props;

        const product = cardProductMap[productid];
        const { productname = '' } = product;

        return (
            <DialogStyle.Content
                // style props
                width="calc(100% - 20px)"
                maxWidth="295px"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="3px"
                // dialog props
                visible
                animation="zoom"
                maskAnimation="fade"
                closable={false}
                maskClosable={false}
                keyboard={false}
                onClose={this.closeDialog}
            >
                <Title>
                    加入購物車
                </Title>
                <Description>
                    商品名稱：{productname.trim()}<br/>
                </Description>
                <CounterWrapper>
                    <Counter
                        number={this.state.quantity}
                        add={this.addTradeNumber}
                        minus={this.minusTradeNumber}
                        handleChange={this.handleCountChange}
                    />
                </CounterWrapper>
                <ActionWrapper>
                    <ButtonGroup>
                        <ConfrimButton onClick={this.addCart} disable={this.state.isLoading}>
                            {
                                this.state.isLoading && (
                                    <GlobalStyle.Spin size="16px" color="#fff" margin="0 10px 0 0" />
                                )
                            }
                            確定
                        </ConfrimButton>
                        <CloseButton outline onClick={this.closeDialog}>
                            取消
                        </CloseButton>
                    </ButtonGroup>
                </ActionWrapper>
            </DialogStyle.Content>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        haslogin: state.member.haslogin,
        productid: state.web.addProductDialog.productid,
        routeToCart: state.web.addProductDialog.routeToCart,
        cardProductMap: state.card.cardProductMap,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        cardCartActions: bindActionCreators(actionCreators.cardCartActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(AddProductDialog);